import React, { useState } from 'react';
import './App.css';
import Home from "./pages/Home.jsx";
import Login from './pages/Login.jsx';
import Signup from './pages/Signup.jsx';
import Chats from './pages/Chats.jsx';

function App() {
  const [screen, setScreen] = useState('logo');

  const handleLogoClick = () => {
    setScreen('login');
  };

  const handleSignupClick = () => {
    setScreen('signup');
  };

  const handleLoginClick = () => {
    setScreen('login');
  };

  const handleloggedInClick = () => {
    setScreen('chats');
  };


  return ( 
    <div className="App">
      {screen === 'logo' && <Home onClick={handleLogoClick} />}
      {screen === 'login' && <Login onSignupClick={handleSignupClick}  onLoginSuccess={handleloggedInClick}/>}
      {screen === 'chats' && <Chats />}
      {screen === 'signup' && <Signup onLoginClick={handleLoginClick} />}
    </div>
  );
}

export default App;


